import React, { useState } from 'react';
import axios from 'axios';
import '../styles/EditPostModal.css';

const EditPostModal = ({ post, onClose, onSave }) => {
  const [content, setContent] = useState(post.content);
  const [visibility, setVisibility] = useState(post.visibility || 'public');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!content.trim()) {
      setError('Content cannot be empty');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/posts/${post._id}`,
        { content, visibility },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      onSave(response.data.post);
      onClose();
    } catch (err) {
      console.error('Error editing post:', err);
      setError(err.response?.data?.message || 'Error editing post');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-post-modal-overlay">
      <div className="edit-post-modal">
        <div className="edit-post-header">
          <h2>✏️ Edit Post</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="edit-post-form">
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="What's on your mind?"
            className="edit-post-textarea"
            maxLength="5000"
          />

          <div className="char-count">
            {content.length}/5000
          </div>

          <div className="edit-post-options">
            <select
              value={visibility}
              onChange={(e) => setVisibility(e.target.value)}
              className="visibility-select"
            >
              <option value="public">🌐 Public</option>
              <option value="followers">👥 Followers Only</option>
              <option value="private">🔒 Private</option>
            </select>

            <div className="edit-post-footer">
              {post.isEdited && (
                <span className="edited-label">Edited</span>
              )}
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="edit-post-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="save-btn"
              disabled={loading || !content.trim()}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPostModal;
